<template>
    <div class="bread-crumb">
      <a-breadcrumb>
        <a-breadcrumb-item href="">
          <a-icon type="home" />
          <span>首页</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item v-for="(item,index) in breadcrumbList" :key="index">
          <a  v-if="index < breadcrumbList.length-1" :href="item.path">{{item.name}}</a>
          <span v-else>{{item.name}}</span>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <h2>{{mainName}}</h2>
    </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    breadcrumbList: {
      type: Array,
      default: () => [
        {
          name: '点位管理',
          path: '/mediaList'
        }
      ]
    },
    mainName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
  .bread-crumb{
    background-color: #fff;
    padding: 16px 32px;
    box-sizing: border-box;
  }
  .bread-crumb h2{
    font-size: 20px;
    margin-top: 16px;
    font-weight: bold;
  }
</style>
